import { io } from "socket.io-client";
import Source from "../../Source";

// virtupet 제어 이벤트를 게이트웨이에서 구독하는 consumer (sub only / event-stream / gateway).
//  - /sub/event-stream/virtupet 연결 → init(token)으로 라우팅 등록(게이트웨이 liveModelSocketMap).
//  - on("request") = 제어판이 pub로 발행한 V-INSTRUCTION/제어 op(updateRules/updateVisibility) 수신만.
//  - pub(발행)은 제어판의 domain/stream/pub/VirtupetPubSocket.js(/pub/event-stream/virtupet). 신원(petId/owner)은 Edge signaling이 담당.
export default class VirtupetGatewaySource extends Source {
  constructor({ token } = {}) {
    super({ provider: "virtupet", kind: "event-stream", mode: "gateway" });
    this._token = token;
    this._socket = null;
  }

  open() {
    const socket = io(`${process.env.VUE_APP_GATEWAY_HOST_URL}/sub/event-stream/virtupet`, {
      transports: ["websocket"],
    });
    this._socket = socket;

    this._setStatus("connecting");
    this._watchGatewayHandshake(socket); // 핸드셰이크 연속 실패 → failed + 원인(E_5XX 등)
    socket.on("connect", () => {
      this._setStatus("ready");
      // 네임스페이스(sub)가 곧 역할. 토큰으로 구독 등록(라우팅용 — 신원은 Edge가 별도 제공).
      // path = 어느 페이지에서 연결했는지(표시용). 제어판이 경로별 연결 분포를 보여주는 데 사용.
      socket.emit("command", {
        method: "init",
        body: { token: this._token, path: window.location.pathname },
      });
    });
    socket.on("disconnect", () => this._setStatus("closed"));

    // 게이트웨이 토큰 거부 시 상태만 반영 (신원 검증은 Edge에서 끝남)
    socket.on("commandResult", (data = {}) => {
      if (data.message === "E_INVALID_BROADCAST_TOKEN" || data.message === "E_TOKEN_REQUIRED") {
        this._setStatus("failed");
      }
    });

    // 제어판이 발행한 이벤트(V-INSTRUCTION 등) + 잔여 제어 op(updateRules/updateVisibility) 수신
    socket.on("request", (event = {}) => this._emit(event));

    return this;
  }

  close() {
    if (this._socket) {
      this._socket.disconnect();
      this._socket = null;
    }
  }
}
